/** FSM 房单 `source` / `order_source` → 概览渠道行文案（与 OrderRoomPreset 一致） */
var FSM_ORDER_SOURCE_MAP = {
    0: "前台",
    1: "中央",
    2: "小程序",
    3: "官网",
    4: "OTA直连",
    5: "企业直连",
};
function labelFromSourceEnumOnly(v) {
    var _a, _b;
    if (v == null || v === "")
        return "其它";
    if (typeof v === "number" && Number.isFinite(v)) {
        var n = Math.trunc(v);
        return (_a = FSM_ORDER_SOURCE_MAP[n]) !== null && _a !== void 0 ? _a : "\u6E20\u9053".concat(n);
    }
    if (typeof v === "string") {
        var t = v.trim();
        if (!t)
            return "其它";
        if (/^\d+$/.test(t)) {
            var n = Number(t);
            if (Number.isFinite(n)) {
                return (_b = FSM_ORDER_SOURCE_MAP[n]) !== null && _b !== void 0 ? _b : "\u6E20\u9053".concat(n);
            }
        }
    }
    return "其它";
}
function channelLabelFromRow(r) {
    var _a;
    return labelFromSourceEnumOnly((_a = r.source) !== null && _a !== void 0 ? _a : r.order_source);
}
/** 房单列表按渠道计数（在住 / 预抵概览条同源） */
export function buildChannelCountsFromOrderRoomList(list) {
    var _a;
    if (!(list === null || list === void 0 ? void 0 : list.length))
        return undefined;
    var m = new Map();
    for (var _i = 0, list_1 = list; _i < list_1.length; _i++) {
        var row = list_1[_i];
        var label = channelLabelFromRow(row);
        m.set(label, ((_a = m.get(label)) !== null && _a !== void 0 ? _a : 0) + 1);
    }
    return Array.from(m.entries())
        .map(function (_a) {
        var label = _a[0], value = _a[1];
        return ({ label: label, value: value });
    })
        .sort(function (a, b) { return b.value - a.value; });
}
